"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _FAZMJLCOcjs = require('./FAZMJLCO.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/popover/popover-heading.tsx
var TagName = "h1";
var usePopoverHeading = _PTOCUU2Dcjs.createHook.call(void 0, 
  function usePopoverHeading2(props) {
    props = _FAZMJLCOcjs.useDialogHeading.call(void 0, props);
    return props;
  }
);
var PopoverHeading = _PTOCUU2Dcjs.forwardRef.call(void 0, function PopoverHeading2(props) {
  const htmlProps = usePopoverHeading(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.usePopoverHeading = usePopoverHeading; exports.PopoverHeading = PopoverHeading;
